<script>
	import { useLocation } from "svelte-navigator";

	import { pageNumber, currentPage } from "../stores/pageStore";

	export let pageList = [];

	const location = useLocation();

	$: {
		$currentPage = pageList.find((p) => p.routeId == $location.pathname);
		if ($currentPage) {
			$pageNumber = $currentPage ? $currentPage.pageIndex : 0;
		} else {
			$currentPage = pageList[0];
			$pageNumber = 0;
		}
	}
</script>

{#if pageList && pageList.length > 0}
	{#if !$currentPage.removeTrackerOnPage}
		<div class="tracker-root no-print">
			{#if $currentPage.showInTracker}
				<div class="row">
					{#each pageList as page}
						{@const visited = page.pageIndex < $pageNumber}
						{@const active = page.pageIndex == $pageNumber}

						{#if page.showInTracker && $pageNumber > 0}
							<div class="col" class:visited class:active></div>
						{/if}
					{/each}
				</div>
			{/if}

			{#if $currentPage.title}
				<div class="page-title">
					{$currentPage.title.toUpperCase()}
				</div>
			{/if}
		</div>
	{/if}
{/if}

<style>
	.tracker-root {
		padding-top: 16px;
		padding-bottom: 40px;
		margin: 0 13.5px;
	}

	.col {
		height: 6px;
		background-color: #000;
	}

	.col.visited,
	.col.active {
		background-color: var(--color-primary);
	}

	.page-title {
		text-align: center;
		padding-top: 10px;
		color: #222;
		font-size: 11px;
		font-weight: 700;
	}
</style>
